import React, { Component, useReducer } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import Localization from "../../../../localization";
import { getMe } from "../../../../redux/selectors/me";
import { isFileValid } from "../../../../utils/helper";
import Button from "../../../../components/button";

class Step3Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            files: [],
        };

        this.myRef = React.createRef();

        this._addFile = this._addFile.bind(this);
        this._removeFile = this._removeFile.bind(this);
    }

    componentDidMount() {
        this.props.myRef(this.myRef);

        if (this.props.values && this.props.values.artist_tax_proof) {
            this._addFile(this.props.values.artist_tax_proof);
        }
    }

    _addFile(event) {
        const { locale } = this.props;

        isFileValid(event).then((result) => {
            if (!result.size) {
                alert(Localization[locale].register.step_9_photo_size);
                return;
            }

            let files = [];
            files.push(event);
            this.myRef.current.setFieldValue("artist_tax_proof", files[0]);
            this.setState({
                files,
            });
        });
    }

    _removeFile(image) {
        let files = this.state.files.slice();

        files = files.filter((item) => item !== image);

        this.myRef.current.setFieldValue("artist_tax_proof", null);

        this.setState({
            files,
        });
    }

    _renderFile() {
        const { files } = this.state;

        if (files.length > 0) {
            return files.map((file) => (
                <div
                    className="cursor-pointer"
                    onClick={() => {
                        this._removeFile(file);
                    }}
                >
                    <p>{file.name}</p>
                </div>
            ));
        }

        return null;
    }

    render() {
        const { locale, values, user } = this.props;

        const registSchema = Yup.object().shape({
            artist_address: Yup.string().required(
                Localization[locale].validation.required
            ),
            artist_postal_code: Yup.string().required(
                Localization[locale].validation.required
            ),
            artist_city: Yup.string().required(
                Localization[locale].validation.required
            ),
            artist_district: Yup.string().required(
                Localization[locale].validation.required
            ),
            artist_country: Yup.string().required(
                Localization[locale].validation.required
            ),
            artist_nationality: Yup.string().required(
                Localization[locale].validation.required
            ),
            artist_tax_proof: Yup.string().required(
                Localization[locale].validation.required
            ),
        });

        const initialValues = {
            artist_address:
                (values && values.artist_address) || user.address || "",
            artist_postal_code:
                (values && values.artist_postal_code) || user.postal_code || "",
            artist_city: (values && values.artist_city) || user.city || "",
            artist_district:
                (values && values.artist_district) || user.district || "",
            artist_country:
                (values && values.artist_country) || user.country || "",
            artist_nif: (values && values.artist_nif) || user.nif || "",
            artist_nationality:
                (values && values.artist_nationality) || user.nationality || "",
            artist_tax_proof: (values && values.artist_tax_proof) || "",
        };

        return (
            <Formik
                initialValues={initialValues}
                validationSchema={registSchema}
                innerRef={this.myRef}
                onSubmit={(values) => {}}
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <p className="font-bold text-20 text-blue mb-16">
                            {
                                Localization[locale].artistic_booking
                                    .step_3_address_title
                            }
                        </p>
                        <div>
                            <Field
                                type="text"
                                name="artist_address"
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                placeholder={
                                    Localization[locale].artistic_booking
                                        .step_3_address_placeholder
                                }
                            />
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="artist_address" />
                            </p>
                        </div>
                        <div className="mt-26 flex">
                            <div className="mr-30 flex-1">
                                <Field
                                    type="text"
                                    name="artist_postal_code"
                                    className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    placeholder={
                                        Localization[locale].artistic_booking
                                            .step_3_postal_placeholder
                                    }
                                />
                                <p className="text-red text-12 mt-6">
                                    <ErrorMessage name="artist_postal_code" />
                                </p>
                            </div>
                            <div className="flex-1">
                                <Field
                                    type="text"
                                    name="artist_city"
                                    className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    placeholder={
                                        Localization[locale].artistic_booking
                                            .step_3_city_placeholder
                                    }
                                />
                                <p className="text-red text-12 mt-6">
                                    <ErrorMessage name="artist_city" />
                                </p>
                            </div>
                        </div>
                        <div className="mt-26 flex">
                            <div className="mr-30 flex-1">
                                <Field
                                    type="text"
                                    name="artist_district"
                                    className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    placeholder={
                                        Localization[locale].artistic_booking
                                            .step_3_district_placeholder
                                    }
                                />
                                <p className="text-red text-12 mt-6">
                                    <ErrorMessage name="artist_district" />
                                </p>
                            </div>
                            <div className="flex-1">
                                <Field
                                    type="text"
                                    name="artist_country"
                                    className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    placeholder={
                                        Localization[locale].artistic_booking
                                            .step_3_country_placeholder
                                    }
                                />
                                <p className="text-red text-12 mt-6">
                                    <ErrorMessage name="artist_country" />
                                </p>
                            </div>
                        </div>
                        <div className="mt-26">
                            <Field
                                type="text"
                                name="artist_nif"
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                placeholder={
                                    Localization[locale].artistic_booking
                                        .step_3_nif_placeholder
                                }
                            />
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="artist_nif" />
                            </p>
                        </div>
                        <div className="mt-26">
                            <Field
                                type="text"
                                name="artist_nationality"
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                placeholder={
                                    Localization[locale].artistic_booking
                                        .step_3_nationality_placeholder
                                }
                            />
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="artist_nationality" />
                            </p>
                        </div>
                        <div className="mt-26">
                            <div className="flex">{this._renderFile()}</div>
                            <div className="w-208 mt-10">
                                <Button
                                    text={
                                        Localization[locale].artistic_booking
                                            .step_3_tax_proof_placeholder
                                    }
                                    textStyle={
                                        "font-bold text-17 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    backgroundColor={"bg-grey"}
                                    onClick={() => {
                                        this._input.click();
                                    }}
                                    wrapperStyle={"px-20"}
                                />
                            </div>
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="artist_tax_proof" />
                            </p>
                            <input
                                type="file"
                                ref={(input) => (this._input = input)}
                                className="hidden"
                                onChange={(event) => {
                                    this._addFile(event.target.files[0]);
                                }}
                                accept="image/jpeg,image/png,application/pdf"
                            />
                            <p className="text-14 mt-6">
                                {
                                    Localization[locale].artistic_booking
                                        .step_3_tax_proof_help
                                }
                            </p>
                        </div>
                    </form>
                )}
            </Formik>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Step3Form);
